/* Cuadro de dialogo para confirmaciones con las siguientes propiedades:
    mensaje: String.Mensaje que muestra el cuadro de dialogo
    abierto: Bool. Si es true, la situación inicial del cuadro de dialogo es visible
    config: Object. Objeto javascript con la configuracion de conexion con el servidor ( ip,puerto,protocolo)
    datosUsuario: Object: Objeto javascript con los datos de un usuario en directorio ldap
    proposito: String. Palabra clave que establece el proposito del envio de datos (e.g. "borrar" para borrar a un usuario)

    El manejador del boton "Si", llama a enviarDatos(proposito) que a su vez llama a un método de envio de datos
    al servidor en funcion de la propiedad "proposito".
* */

import './../../CSS/Estilo.css';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import {useState} from "react";
import {fetchRequest} from "../RequestUtils";

export default function Dialogo({abierto,proposito,datosUsuario,config,mensaje})
{
    const [open, setOpen] = useState(abierto)

    /////////////////////////////////
    //
    //  MANEJADOR DEL BOTON ",No"
    //  CIERRA EL CUADRO DE DIALOGO Y RECARGA LA PÁGINA
    //
    /////////////////////////////////////////////
    //
    function cerrarDialogo() {
        setOpen(() => false)
        window.location.reload();
    }

    /////////////////////////////////////////////////
    //
    //  MANEJADOR DEL BOTON SI
    //  LLAMA A UNA FUNCION DE ENVIO DE DATOS CORRESPONDIENTE A
    //  LA PROPIEDAD proposito ESTABLECIDA EN EL COMPONENTE PADRE
    //
    //////////////////////////////////////////////////////////
    //
    function enviarDatos()
    {
        switch (proposito) {
            case 'borrar':
                enviarDatosParaBorrarUsuario();
                break;
            default:
                alert("No se ha podido determinar el propósito de envio de datos en Dialogo::enviarDatos");
                break;
        }
        setOpen(()=>false);
    }

    ///////////////////////////////////////////////////
    //
    // ENVIA LA PETCION deleteUser AL SERVIDOR PARA BORRAR LOS DATOS
    // Y FICHEROS DEL USUARIO CUYO PASSWORD CORRESPONDE A LA PROPIEDAD
    // userPassword DEL OBJETO EN LA PROPIEDAD datosUsuario ENVIADA POR
    // EL COMPONENTE PADRE
    //
    /////////////////////////////////////////////////////////////
    //
    function enviarDatosParaBorrarUsuario() {
        const callback = (response) =>{
            if(response) {
                if(response.data.deleteUser) {
                    alert("Usuario borrado con éxito.");
                    window.location.reload();
                }
                else
                    alert("Usuario no encontrado");
            }
            else
                alert("Error, no se ha recibido respuesta del servidor");
        }
        //Obtener el token del usuario administrador que envia la peticion
        let tokenAdmin = sessionStorage.getItem('token');
        fetchRequest('deleteUser',
            [{nombre: 'userPassword', valor: datosUsuario.userPassword},
                {nombre:'tokenAdmin',valor:tokenAdmin},
                {nombre:'uid',valor:datosUsuario.uid}],
            'POST', config.ip, config.port, config.protocolo, 'json', callback);
    }

    return(
        <Dialog id={'dialog'} open={open}>
            <DialogTitle sx={{background:'darkcyan'}}>{mensaje}</DialogTitle>
            <DialogActions sx={{display:'flex',backgroundColor:'darkcyan',justifyContent:'space-evenly'}}>
                <Button id={'btSi'} onClick={enviarDatos}>Si</Button>
                <Button id={'btNo'} onClick={cerrarDialogo}>No</Button>
            </DialogActions>
        </Dialog>
    )
}